import moment from 'moment';
import React from 'react';
import { Spinner, Table } from 'reactstrap';
import { Routes } from '../../routes';
import { useHistory } from 'react-router-dom';

// Sample data (this should be replaced with actual data fetched from your API)
// const auditLogs = [
//     {
//         id: 1,
//         username: 'Brainstorm.ng',
//         taxID: 13,
//         phone: '09124611644',
//         email: 'hello@brainstorm.ng',
//         mda_name: '',
//         method: 'GET',
//         route: '/search-tax-clearance?status=initiated&search=',
//         action: 'View',
//         timestamp: '2024-10-23 11:36:21',
//         ip: '::1',
//         sector: null,
//         parameters: JSON.stringify({ status: 'initiated', search: '', in_from: '2024-10-23' }),
//         createdAt: '2024-10-23 11:36:21',
//     },
//     {
//         id: 2,
//         username: 'Brainstorm.ng',
//         taxID: 13,
//         phone: '09124611644',
//         email: 'hello@brainstorm.ng',
//         mda_name: '',
//         method: 'GET',
//         route: '/get/tax-clearance?query_type=select-status&status=initiated',
//         action: 'View',
//         timestamp: '2024-10-23 11:36:23',
//         ip: '::1',
//         sector: null,
//         parameters: JSON.stringify({ query_type: 'select-status', status: 'initiated' }),
//         createdAt: '2024-10-23 11:36:23',
//     },
//     // Add more rows as needed
// ];

const AuditLogDetails = ({data=[]}) => {
    const history = useHistory()
    return data.length ? (
        <div className="container mt-5">
            <h2>{data[0].username}'s Audit Logs</h2>
            <table>
                <thead>

                <tr>
                        <th>KIRMAS-ID</th>
                        <th>{data[0].taxID}</th>
                    </tr>

                    <tr>
                        <th>Phone</th>
                        <th>{data[0].phone}</th>
                    </tr>

                    <tr>
                        <th>Email</th>
                        <th>{data[0].email}</th>
                    </tr>

                    <tr>
                        <th>MDA Name</th>
                        <th>{data[0].mda_name}</th>
                    </tr>

                    </thead>
                </table>
            <Table responsive>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Timestamp</th>
                        <th>IP</th>
                        <th>Route</th>
                        <th>Method</th>
                        <th>Action</th>
                        <th>Params</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((log,idx) => (
                        <tr style={{cursor:'pointer'}} onClick={()=>history.push(`${Routes.AuditLogsView.path}?kirmas_id=${log.taxID}`)} key={idx}>
                            <td>{idx+1}</td>
                            <td>{moment(log.timestamp).format('DD/MM/YYYY HH:mm:ss A')}</td>
                            <td>{log.ip}</td>
                            <td>{log.route}</td>
                            <td>{log.method}</td>
                            <td>{log.action}</td>
                            <td>{log.parameters}</td>
                            
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    ):<div className="text-center"><Spinner /></div>
};

export default AuditLogDetails;
